import {AdminPagingModel} from "./AdminPagingModel";
import {PluginService} from "../../services/PluginService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Plugin} from "../../entities/Plugin";

export class PluginAdminPagingModel extends AdminPagingModel<Plugin>{
  static $inject = ['$q','PluginService','NotificationService','GridBookmarkService'];
  constructor($q:ng.IQService, pagingService:PluginService,notificationService:NotificationService,
              gridBookmarkService:GridBookmarkService){
    super($q, pagingService,notificationService,gridBookmarkService);
  }
  getCustomActions():string[]{
    return [];
  }
  entityName():string{
    return "plugin";
  }
  displayName():string{
    return "Plugins";
  }
  getColumnDefs():ng.IPromise<void>{
    this.nameValuePairs = [['name','Name', null],['description','Description', null]];
    return this.$q.when();
  }
}
